function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#cf142b",
    d: "M 225.5,-0.5 C 241.5,-0.5 257.5,-0.5 273.5,-0.5C 282.02,0.909111 290.687,2.24244 299.5,3.5C 299.5,68.8333 299.5,134.167 299.5,199.5C 364.833,199.5 430.167,199.5 495.5,199.5C 496.748,207.982 498.081,216.315 499.5,224.5C 499.5,241.167 499.5,257.833 499.5,274.5C 498.183,282.703 496.85,291.036 495.5,299.5C 430.167,299.5 364.833,299.5 299.5,299.5C 299.5,364.833 299.5,430.167 299.5,495.5C 291.018,496.748 282.685,498.081 274.5,499.5C 257.833,499.5 241.167,499.5 224.5,499.5C 216.315,498.081 207.982,496.748 199.5,495.5C 199.5,430.167 199.5,364.833 199.5,299.5C 134.167,299.5 68.8333,299.5 3.5,299.5C 2.24244,290.687 0.909111,282.02 -0.5,273.5C -0.5,257.5 -0.5,241.5 -0.5,225.5C 0.909111,216.98 2.24244,208.313 3.5,199.5C 68.8333,199.5 134.167,199.5 199.5,199.5C 199.5,134.167 199.5,68.8333 199.5,3.5C 208.313,2.24244 216.98,0.909111 225.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fefdfe",
    d: "M 299.5,3.5 C 310.815,6.05169 321.815,9.38502 332.5,13.5C 332.333,62.8345 332.5,112.168 333,161.5C 372.604,141.615 412.104,121.615 451.5,101.5C 455.189,105.865 458.522,110.531 461.5,115.5C 428.98,131.593 396.647,147.926 364.5,164.5C 363.244,164.461 362.244,164.961 361.5,166C 380.338,166.829 399.005,166.662 417.5,165.5C 436.167,156.167 454.833,146.833 473.5,137.5C 483.392,157.172 490.726,177.839 495.5,199.5C 430.167,199.5 364.833,199.5 299.5,199.5C 299.5,134.167 299.5,68.8333 299.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fefefe",
    d: "M 198.5,4.5 C 198.5,69.1667 198.5,133.833 198.5,198.5C 133.833,198.5 69.1667,198.5 4.5,198.5C 6.6304,185.299 10.2971,172.632 15.5,160.5C 19.0432,162.438 22.7099,164.105 26.5,165.5C 44.662,166.662 62.9954,166.829 81.5,166C 80.9558,165.283 80.2891,164.783 79.5,164.5C 61.4954,155.498 43.4954,146.498 25.5,137.5C 31.2796,125.064 38.2796,113.398 46.5,102.5C 86.1039,121.302 125.437,140.635 164.5,160.5C 164.56,161.043 164.893,161.376 165.5,161.5C 166.5,112.171 166.833,62.8378 166.5,13.5C 176.723,9.27466 187.39,6.27466 198.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#00237c",
    d: "M 165.5,13.5 C 165.832,62.6695 165.499,111.67 164.5,160.5C 125.437,140.635 86.1039,121.302 46.5,102.5C 77.2321,60.9591 116.899,31.2924 165.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#8798c2",
    d: "M 165.5,13.5 C 165.833,13.5 166.167,13.5 166.5,13.5C 166.833,62.8378 166.5,112.171 165.5,161.5C 164.893,161.376 164.56,161.043 164.5,160.5C 165.499,111.67 165.832,62.6695 165.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#01247d",
    d: "M 332.5,13.5 C 381.258,30.5977 420.924,59.931 451.5,101.5C 412.104,121.615 372.604,141.615 333,161.5C 332.5,112.168 332.333,62.8345 332.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#cf162b",
    d: "M 461.5,115.5 C 466.02,122.54 470.02,129.874 473.5,137.5C 454.833,146.833 436.167,156.167 417.5,165.5C 399.659,165.83 381.992,165.497 364.5,164.5C 396.647,147.926 428.98,131.593 461.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#cf182c",
    d: "M 25.5,137.5 C 43.4954,146.498 61.4954,155.498 79.5,164.5C 62.0079,165.497 44.3412,165.83 26.5,165.5C 22.7099,164.105 19.0432,162.438 15.5,160.5C 18.0469,152.415 21.3802,144.748 25.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d84053",
    d: "M 79.5,164.5 C 80.2891,164.783 80.9558,165.283 81.5,166C 62.9954,166.829 44.662,166.662 26.5,165.5C 44.3412,165.83 62.0079,165.497 79.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db5262",
    d: "M 364.5,164.5 C 381.992,165.497 399.659,165.83 417.5,165.5C 399.005,166.662 380.338,166.829 361.5,166C 362.244,164.961 363.244,164.461 364.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#f6d4d8",
    d: "M 199.5,3.5 C 199.5,68.8333 199.5,134.167 199.5,199.5C 134.167,199.5 68.8333,199.5 3.5,199.5C 3.5,198.833 3.83333,198.5 4.5,198.5C 69.1667,198.5 133.833,198.5 198.5,198.5C 198.5,133.833 198.5,69.1667 198.5,4.5C 198.5,3.83333 198.833,3.5 199.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fefdfd",
    d: "M 3.5,299.5 C 68.8333,299.5 134.167,299.5 199.5,299.5C 199.5,364.833 199.5,430.167 199.5,495.5C 188.099,493.237 177.099,489.903 166.5,485.5C 166.833,436.162 166.5,386.829 165.5,337.5C 164.893,337.624 164.56,337.957 164.5,338.5C 125.406,358.38 86.0729,377.714 46.5,396.5C 43.2533,392.341 40.2533,388.008 37.5,383.5C 69.8833,366.642 102.55,350.308 135.5,334.5C 136.289,334.217 136.956,333.717 137.5,333C 118.662,332.171 99.9955,332.338 81.5,333.5C 62.5157,342.325 43.8491,351.659 25.5,361.5C 15.6077,341.828 8.27435,321.161 3.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fefefe",
    d: "M 495.5,299.5 C 492.682,312.949 488.682,325.949 483.5,338.5C 479.71,337.105 476.043,335.438 472.5,333.5C 454.005,332.338 435.338,332.171 416.5,333C 417.044,333.717 417.711,334.217 418.5,334.5C 436.679,343.756 455.013,352.756 473.5,361.5C 467.769,373.968 460.769,385.634 452.5,396.5C 451.5,396.5 450.5,396.5 449.5,396.5C 411.818,376.992 373.818,357.992 335.5,339.5C 334.791,338.596 333.791,338.263 332.5,338.5C 332.5,387.5 332.5,436.5 332.5,485.5C 321.912,489.901 310.912,493.235 299.5,495.5C 299.5,430.167 299.5,364.833 299.5,299.5C 364.833,299.5 430.167,299.5 495.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e06675",
    d: "M 81.5,333.5 C 99.9955,332.338 118.662,332.171 137.5,333C 136.956,333.717 136.289,334.217 135.5,334.5C 117.674,333.503 99.6744,333.17 81.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dd5969",
    d: "M 472.5,333.5 C 454.326,333.17 436.326,333.503 418.5,334.5C 417.711,334.217 417.044,333.717 416.5,333C 435.338,332.171 454.005,332.338 472.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#cf152b",
    d: "M 81.5,333.5 C 99.6744,333.17 117.674,333.503 135.5,334.5C 102.55,350.308 69.8833,366.642 37.5,383.5C 32.9795,376.46 28.9795,369.126 25.5,361.5C 43.8491,351.659 62.5157,342.325 81.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#cf182c",
    d: "M 418.5,334.5 C 436.326,333.503 454.326,333.17 472.5,333.5C 476.043,335.438 479.71,337.105 483.5,338.5C 480.959,346.575 477.626,354.241 473.5,361.5C 455.013,352.756 436.679,343.756 418.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#8798c2",
    d: "M 164.5,338.5 C 164.56,337.957 164.893,337.624 165.5,337.5C 166.5,386.829 166.833,436.162 166.5,485.5C 166.167,485.5 165.833,485.5 165.5,485.5C 165.832,436.33 165.499,387.33 164.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#00237c",
    d: "M 164.5,338.5 C 165.499,387.33 165.832,436.33 165.5,485.5C 116.899,467.708 77.2321,438.041 46.5,396.5C 86.0729,377.714 125.406,358.38 164.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#00247d",
    d: "M 335.5,339.5 C 372.845,359.506 410.845,378.506 449.5,396.5C 450.5,396.5 451.5,396.5 452.5,396.5C 421.898,438.805 381.898,468.471 332.5,485.5C 332.5,436.5 332.5,387.5 332.5,338.5C 333.791,338.263 334.791,338.596 335.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#243185",
    d: "M 335.5,339.5 C 373.818,357.992 411.818,376.992 449.5,396.5C 410.845,378.506 372.845,359.506 335.5,339.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.582c02f4f6b1b1fc77d9e9f16fcdcb47.svg";
export { ForwardRef as ReactComponent };